import { FC } from 'react'

import ConnectedSynchronizations from './connectors/ConnectedSynchronizations/ConnectedSynchronizations'

const Synchronizations: FC = () => (
    <ConnectedSynchronizations />
)

export default Synchronizations
